export const clients = {
  API: 'api',
};
